var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"circle",class:{
      circleActive: _vm.status === _vm.statusTypes.PAID,
      circleError: _vm.status === _vm.statusTypes.ERROR
    }},[_c('div',{staticClass:"circleInner",class:{
        circleInnerActive: _vm.status === _vm.statusTypes.PAID,
        circleInnerError: _vm.status === _vm.statusTypes.ERROR
      }})]),_c('div',{staticClass:"timelineContent"},[_c('p',{staticClass:"timelineText"},[_vm._v(_vm._s(_vm.value))]),_c('p',{staticClass:"timelineSubtitle"},[_vm._v(_vm._s(_vm.subtitle))]),_c('v-chip',{staticClass:"mt-3",attrs:{"color":_vm.statusColor,"dark":"","small":"","label":""}},[_vm._v(" "+_vm._s(_vm.statusText)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }